import { AnalyticsEvent, AnalyticsRepositoryType } from '51trips-frontend-core'

export class AnalyticsRepository implements AnalyticsRepositoryType {
  setAnalyticsEnabled(isEnabled: boolean): void {
    // TODO: fix me
    console.log('[51T] setAnalyticsEnabled called', isEnabled)
  }
  logEvent(event: AnalyticsEvent): void {
    // TODO: fix me
    console.log('[51T] logEvent called', event)
  }
  trackScreen(screenName: string): void {
    // TODO: fix me
    console.log('[51T] trackScreen called', screenName)
  }
}
